const MEDIA_TYPE_LABELS: Record<string, string> = {
  'application/mcp-server+json': 'MCP server',
  'application/mcp-server-card+json': 'MCP server',
  'application/agent-skills+md': 'Skill',
  'application/ai-skill': 'Skill',
  'application/vnd.github.copilot-plugin': 'Plugin',
  'application/agents+md': 'Agent',
  'application/agent+json': 'Agent',
  'application/a2a-agent-card+json': 'A2A agent',
  'application/canvas+json': 'Canvas',
}

const MEDIA_TYPES_BY_LABEL = new Map<string, string>()

for (const [mediaType, label] of Object.entries(MEDIA_TYPE_LABELS)) {
  const normalizedLabel = label.toLowerCase()
  if (!MEDIA_TYPES_BY_LABEL.has(normalizedLabel)) {
    MEDIA_TYPES_BY_LABEL.set(normalizedLabel, mediaType)
  }
}

export function getMediaTypeLabel(mediaType: string): string {
  return MEDIA_TYPE_LABELS[mediaType] ?? mediaType
}

export function normalizeMediaType(value: string): string {
  const trimmedValue = value.trim()
  return MEDIA_TYPES_BY_LABEL.get(trimmedValue.toLowerCase()) ?? trimmedValue
}

export function normalizeMediaTypes(values: Iterable<string>): string[] {
  const normalizedValues = new Set<string>()

  for (const value of values) {
    const mediaType = normalizeMediaType(value)
    if (mediaType) normalizedValues.add(mediaType)
  }

  return [...normalizedValues]
}
